import React from 'react';
import propTypes from 'prop-types';
;
import { Button, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal } from 'src/ui/mui-ui-kit';;
import { usePoseWithBulma } from 'src/ui/hooks';
import { FadeInDiv, AnimatedCard } from 'src/ui';

const KEY_DIRECTIONS = {
  CO: {
    title: 'Generate a Metrc Key',
    directions: (
      <ol>
        <li>
          Log in to your Metrc account by visiting{' '}
          <a href="https://www.metrc.com/">https://www.metrc.com/</a>.
        </li>
        <li>
          Click on &quot;Login&quot; located in the upper right corner of the
          page.
        </li>
        <li>Choose your state and log in using your credentials.</li>
        <li>
          After signing in, locate the down arrow next to your license name in
          the upper right corner of the page.
        </li>
        <li>Click on &quot;API Keys&quot; from the drop-down menu.</li>
        <li>Select the &quot;Generate API Key&quot; button.</li>
        <li>
          Once the API key is generated, use your cursor to copy it for further
          use.
        </li>
      </ol>
    ),
  },
};

export function DirectionsModal({ isActive, onCancel, state }) {
  const { title, directions } = KEY_DIRECTIONS[state];
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  return (
    <Modal isActive={isModalVisible} className="add-account-invitation">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h6"
            hasTextAlign="centered"
            className="has-text-weight-semibold"
          >
            {title || ''}
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody>
          {/* <div dangerouslySetInnerHTML={{ __html: directions || null }} /> */}
          {directions}
          <div className="buttons is-centered">
            <Button
              isOutlined
              className="is-long"
              hasTextColor="info"
              onClick={onCancel}
            >
              Close
            </Button>
          </div>
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

DirectionsModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  state: propTypes.string.isRequired,
};
